/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const EmployeeEntityHeader = () => {
  return (
    <EntityHeader badges={[]} hasAuthor={false} defaultAuthor={DEFAULT_ENTITY_AUTHOR}>
      <div />
    </EntityHeader>
  );
};

export default EmployeeEntityHeader;
